﻿//Commentaire



type ObservableObject = kendo.data.ObservableObject;

    export class String {
        static IsNullOrEmpty = (str: string): boolean => {
            return (str == null || str == "" || str == undefined);
        };

        static get GuidRegexPattern(): RegExp {
            return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        }

        static FormatNullableStringToString = (n?: string): string => {
            return (String.IsNullOrEmpty(n) == true) ? "" : n;
        };

        static Base64Encode = (str: string): string => {
            return window.btoa(str);
        }

        static get GetEmptyGuid(): string {
            return "00000000-0000-0000-0000-000000000000";
        }

        static IsGuid = (str: string): boolean => {
            const guidRegex = this.GuidRegexPattern;
            return guidRegex.test(str);
        }

        static get NewGuid(): string {
            let s = [];
            let hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            return s.join("");
        }
    }

    export class DateTime {
        static IsDateEqual = (d1: Date, d2: Date): boolean => {
            return (d1.getDate() == d2.getDate() &&
                d1.getMonth() == d2.getMonth() &&
                d1.getFullYear() == d2.getFullYear());
        };

        /**
         * Ajoute le time zone à la valeur de la propriété d'un objet.
         * On passe l'objet et la propriété à modifier.'
         */
        static addTimeZoneOffset = (obj: any, prop: string): void => {
            if (obj == null) throw new Error("Add time zone : objet null");

            let el = obj[prop];

            obj[prop] = (el == null) ? null : DateTime._addTimeZoneOffset(el);
        };

        static ToUtc = (d: Date): Date => {
            return new Date(d.getUTCFullYear(),
                d.getUTCMonth(),
                d.getUTCDate(),
                d.getUTCHours(),
                d.getUTCMinutes(),
                d.getUTCSeconds());

        };


        static GetDateTimeZoneOffset = (d?: any): Date => {

            if (d == null) return null;

            return DateTime._addTimeZoneOffset(d);
        };

        private static _addTimeZoneOffset = (val: any): Date => {
            let d = kendo.parseDate(val);

            if (val == null || d == null)
                throw new Error("Add time zone : la valeur n'est pas une date");

            let t = d.getTime() - (d.getTimezoneOffset()) * 60000;

            return new Date(t);

        };

        static PrepareDateForWidget = (d?: Date): Date => {

            if (d == null)
                return null;

            return kendo.parseDate(d.toString());
        };

        static GetLastDateForAMonth = (month: number, year: number): DateTime => {

            let m31 = [0, 2, 4, 6, 7, 9, 11];

            if (year % 4 == 0 && month == 1)
                return new Date(year, month, 29);

            if (year % 4 != 0 && month == 1)
                return new Date(year, month, 28);

            return m31.indexOf(month) >= 0 ? new Date(year, month, 31) : new Date(year, month, 30);

        };

        static AddDays = (date: Date, day: number): Date => {
            let result = new Date(date);
            result.setDate(date.getDate() + day);
            return new Date(result);
        };

        static AddMonths = (dateObject: Date, months: number): Date => {
            let day = dateObject.getDate(); // returns day of the month number

            // avoid date calculation errors
            dateObject.setHours(20);

            // add months and set date to last day of the correct month
            dateObject.setMonth(dateObject.getMonth() + months + 1, 0);

            // set day number to min of either the original one or last day of month
            dateObject.setDate(Math.min(day, dateObject.getDate()));

            return dateObject

        }

        static MonthToString = (monthNumber: number, IsBaseZero?: boolean): string => {
            if (IsBaseZero)
                monthNumber++;

            if (monthNumber < 1 || monthNumber > 12) {
                throw new Error("Le mois n'est pas correct");
            }

            switch (monthNumber) {
                case 1:
                    return "janvier";
                case 2:
                    return "février";
                case 3:
                    return "mars";
                case 4:
                    return "avril";
                case 5:
                    return "mai";
                case 6:
                    return "juin";
                case 7:
                    return "juillet";
                case 8:
                    return "aout";
                case 10:
                    return "septembre";
                case 11:
                    return "novembre";
                case 12:
                    return "décempbre";
            }

        }

        // Vérifie qu'un objet soit bien une date au format  ISO 8601
        static IsDate = (value: any) => {
            return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)
        }

        // Pour chaque propriété d'un objet.
        // Si la propriété est de type Date, convertit la valeur au formatDate.
        static ConvertDates = <T, >(data: T): T =>
            Array.isArray(data)
                ? data.map(this.ConvertDates) as unknown as T
                : typeof data === 'object' && data !== null
                    ? Object.fromEntries(
                        Object.entries(data).map(([key, value]) => [
                            key,
                            typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)
                                ? new Date(value) // Conversion en Date si c'est un format ISO 8601
                                : typeof value === 'object' && value !== null
                                    ? this.ConvertDates(value) // Appel récursif pour les objets imbriqués
                                    : value
                        ])
                    ) as T
                    : data;

    }

    export class HtmlElement {
        static RemoveAllHandler = (element: HTMLElement): HTMLElement => {
            let clone = element.cloneNode(true);
            element.parentNode.replaceChild(clone, element);

            return clone as HTMLElement;
        }
        
        static loadCssOnce = (url: string) : Promise<void> => {
           return new Promise((resolve, reject) => {
               if (document.querySelector(`link[href="${url}"]`)) {
                   resolve();
                   return
               }

               const link = document.createElement("link");
               link.rel = "stylesheet";
               link.href = url;
               link.onload = () => resolve();
               link.onerror = () => reject(new Error("Failed to load " + url));
               document.head.appendChild(link);
               
           })
        }
        
        static LoadScriptOnce = async (url: string) : Promise<void> => {
            return new Promise((resolve, reject) => {
                // Déjà chargé ?
                if (document.querySelector(`script[src="${url}"]`)) {
                    resolve();
                    return;
                }

                const script = document.createElement("script");
                script.src = url;
                script.async = true;
                script.onload = () => resolve();
                script.onerror = () => reject(new Error("Failed to load " + url));
                document.body.appendChild(script);
            });
        }
    }

    export class StaticMenu {
        static ToogleMenuItem = (selector: string) => {
            $(".sidebar .nav li").removeClass("active");
            $(".sidebar .nav " + selector).addClass("active");
        }
    }

    export class Mosaique {
        static runMosaicView = (): void => {
            $(".customgrid tbody td").each((index, element) => {
                let attrClass = $(element).attr("class");
                $(".customgrid thead").hide(); // IMPORTANT
                $(".run-mosaic").addClass("active"); // IMPORTANT
                $(".run-line").removeClass("active"); // IMPORTANT
                $(element).replaceWith("<div class='" + attrClass + "'>" + $(element).html() + "</div>");

            });
            $(".customgrid tbody tr").each((index, element) => {
                let rowClass = $(element).attr("class");
                $(element).replaceWith("<div class='" + rowClass + "'>" + $(element).html() + "</div>");

            });
        };

        static runTableView = (): void => {
            $('.customgrid tbody div.item-view div').each((index, element) => {
                let attrClass = $(element).attr("class");
                $(".customgrid thead").show(); // IMPORTANT
                $(".run-mosaic").removeClass("active"); // IMPORTANT
                $(".run-line").addClass("active"); // IMPORTANT
                $(element).replaceWith("<td class='" + attrClass + "'>" + $(element).html() + "</td>");

            });
            $('.customgrid tbody div.item-view').each((index, element) => {
                let rowClass = $(element).attr("class");
                $(element).replaceWith("<tr class='" + rowClass + "'>" + $(element).html() + "</tr>");

            });
        };


    }

    export class KendoDataObject {
    
        static CopyProperty = (source: ObservableObject, destination: ObservableObject, property: string) => {
            destination.set(property, source.get(property));
        }

        static CopyFull = (source: ObservableObject, destination: ObservableObject) => {
            for (var prop in source) {

                if (prop.indexOf("_") == 0)
                    continue;

                if (typeof source[prop] == "function")
                    continue;

                if (prop == "uid")
                    continue;

                destination.set(prop, source.get(prop));
            }
        }

        static CopyProperties = async (source: ObservableObject, destination: ObservableObject, properties: Array<string>) => {
            properties.forEach(x => {
                destination.set(x, source.get(x))
            });
        }
    }

    export class ContextMenu {
        static DetectContextualPosition = (container: JQuery, cssClass = ".item-panel") => {
            let windowHeight = $(window).height();

            container.find(cssClass).each((index, element) => {

                let action = $(element).find(".action");
                let actionOffset = action.offset();
                let offsetLimit = (windowHeight / 2) + (windowHeight / 4);

                if (actionOffset.top > offsetLimit) {
                    $(element).find(".action").addClass("context-top");
                }

            });
        }
    }

    export class KendoToolBarHandler {
        public static AsyncToolbarHandle = (target: HTMLElement, callBack: () => Promise<any>) => {
            const button = $(target).closest(".k-button");
            const originalIcon = button.find(".k-icon").detach();
            const loader = $("<span>").kendoLoader({
                size: "small",
                themeColor: "secondary",
            }).data("kendoLoader");
            button.append(loader.element);

            callBack().finally(() => {
                loader.destroy();
                button.find("span.k-loader").remove();
                button.prepend(originalIcon);
            })
        }
    }

    export class GowebEvent {
        // Modifier le paramètre => ... arg: array<any> => ...arg: any
        // Intégration d'un type générique ?
        private _items: Array<(...arg: Array<any>) => void>;

        constructor() {
            this._items = new Array<(...arg: Array<any>) => void>();
        }

        public Bind = (callBack: (...arg: Array<any>) => void, eventKey?: string) => {
            if (!String.IsNullOrEmpty(eventKey))
                callBack["EventKey"] = eventKey;

            this._items.push(callBack)
        };
        public HasEvents = () => this._items.length > 0;
        public Clear = async (key?: string) => {
            if (String.IsNullOrEmpty(key)) {
                this._items = new Array<(...arg: Array<any>) => void>();
                return;
            }

            const o = this._items.find(x => x["EventKey"] == key);

            if (o != null) {
                this._items = this._items.splice(this._items.indexOf(o) + 1, 1);
            }


        }

        public Fire = (...arg: any) => this._items.forEach(async (x) => {
            x(arg);
        });
    }
